import python from '../src/images/python1.png'
import sk from '../src/images/sk.png'
import tf from '../src/images/tf.png'
import sql from '../src/images/sql.png'
import rdx from '../src/images/rrdx1.png'
import jsjq from '../src/images/jsjq.png'
import node from '../src/images/node.png'
import mongo from '../src/images/mongo.png'
import ts from '../src/images/ts.png'
import puppeteer from '../src/images/puppeteer.png'
import tailwind from '../src/images/tailwind.png'
import nextjs from '../src/images/nextjs.png'
import prom from '../src/images/prom.png'
import go from '../src/images/go.png'
import docker from '../src/images/docker.png'
import aws from '../src/images/aws.jpg'
import otel from '../src/images/otel.png'
import k8s from '../src/images/k8s.png'
import playwright from '../src/images/playwright.png'
import jenkins from '../src/images/jenkins.png'
import django from '../src/images/django.png'
import c from '../src/images/c.png'
import java from '../src/images/java.png'
import mysql from '../src/images/mysql.png'
import prismaorm from '../src/images/prisma.jpg'
import pytest from '../src/images/pytest.png'

// need to add skills, internships thats it, not worth the effort honestly.
export const Skillsdata = () => {
    return [
        {
            group: 'Software Engineering',
            skills: [
                {
                    title: 'Python',
                    mainImg: python,
                    completed: 90,
                },
                {
                    title: 'Golang',
                    mainImg: go,
                    completed: 60,
                },
                {
                    title: 'C',
                    mainImg: c,
                    completed: 70,
                },
                {
                    title: 'Java',
                    mainImg: java,
                    completed: 50,
                },
            ],
        },
        {
            group: 'Web and App Dev',
            skills: [
                {
                    title: 'React and Redux',
                    mainImg: rdx,
                    completed: 90,
                },
                {
                    title: 'NextJS',
                    mainImg: nextjs,
                    completed: 60,
                },
                {
                    title: 'Tailwind CSS',
                    mainImg: tailwind,
                    completed: 60,
                },
                {
                    title: 'Puppeteer',
                    mainImg: puppeteer,
                    completed: 80,
                },
                {
                    title: 'PostgreSQL',
                    mainImg: sql,
                    completed: 50,
                },
                {
                    title: 'MySQL',
                    mainImg: mysql,
                    completed: 60,
                },
                {
                    title: 'Prisma ORM',
                    mainImg: prismaorm,
                    completed: 60,
                },
                {
                    title: 'NodeJS-Express',
                    mainImg: node,
                    completed: 90,
                },
                {
                    title: 'MongoDB',
                    mainImg: mongo,
                    completed: 90,
                },
                {
                    title: 'Javascript',
                    mainImg: jsjq,
                    completed: 90,
                },
                {
                    title: 'TypeScript',
                    mainImg: ts,
                    completed: 50,
                },
                {
                    title: 'Django',
                    mainImg: django,
                    completed: 70,
                },
            ],
        },
        {
            group: 'DevOps, CI/CD and Testing',
            skills: [
                {
                    title: 'Docker',
                    mainImg: docker,
                    completed: 90,
                },
                {
                    title: 'AWS',
                    mainImg: aws,
                    completed: 90,
                },
                {
                    title: 'Prometheus',
                    mainImg: prom,
                    completed: 70,
                },
                {
                    title: 'OpenTelemetry',
                    mainImg: otel,
                    completed: 70,
                },
                {
                    title: 'Kubernetes',
                    mainImg: k8s,
                    completed: 80,
                },
                {
                    title: 'Jenkins',
                    mainImg: jenkins,
                    completed: 70,
                },
                {
                    title: 'Pytest',
                    mainImg: pytest,
                    completed: 70,
                },
                {
                    title: 'Playwright',
                    mainImg: playwright,
                    completed: 80,
                },
            ],
        },
        {
            group: 'Machine Learning and Artificial implementation',
            skills: [
                {
                    title: 'ML Model Implementation',
                    mainImg: sk,
                    completed: 60,
                },
                {
                    title: 'TensorFlow with Keras API',
                    mainImg: tf,
                    completed: 50,
                },
            ],
        },
    ]
}
